import AnnotateDomainSequencesSettingsModal from 'antibodies/domain-annotation/AnnotateDomainSequencesSettingsModal';
import {DomainSequenceType} from 'antibodies/domain-annotation/DomainAnnotationTypes';
import startDomainSequenceAnnotation from 'antibodies/domain-annotation/startDomainSequenceAnnotation';
import {ZINDEX_MODAL} from 'styles/StyleConstants';
import runModal from 'ui-library/runModal';

/**
 * Prompts for annotation settings and starts annotating existing domain sequences of one sequence type.
 * Dismissing the modal annotates nothing.
 *
 * @param initialFolderId Prefills the folder for the annotation results dataset.
 * @param onAnnotated See `startDomainSequenceAnnotation`.
 */
export default async function promptAndAnnotateDomainSequences({
  sequenceIds,
  sequenceType,
  initialFolderId,
  onAnnotated,
}: {
  sequenceIds: Array<string>;
  sequenceType: DomainSequenceType;
  initialFolderId: string | null;
  onAnnotated?: (annotatedSequenceIds: Array<string>) => void;
}): Promise<void> {
  const config = await runModal(
    AnnotateDomainSequencesSettingsModal,
    {
      sequenceType,
      initialFolderId,
      submitButtonText: 'Annotate',
      showAnnotationToggle: false,
    },
    {
      title: `Annotate ${sequenceType} domain entities`,
      size: 'lg',
      zIndex: ZINDEX_MODAL,
    }
  );
  if (config == null) {
    return;
  }
  startDomainSequenceAnnotation({sequenceIds, config, onAnnotated});
}
